import { createPinia } from 'ui.vue3.pinia';
import {BitrixVue} from "ui.vue3";
import {PopularCourses} from "./components/home/popular-courses";
import {useCoursesStore} from "../../../catalog/courses/src/stores/courses";

export class PersonalCourses
{
	#application;
	constructor(rootNode) {
		this.rootNode = document.querySelector(rootNode);
	}

	popular() {
		this.getPopular()
	}

	getPopular() {
		const pinia = createPinia();
		const context = this;
		this.#application = BitrixVue.createApp({
			components: {
				PopularCourses
			},
			setup() {
				const coursesStore = useCoursesStore();
				coursesStore.perPage = 3;
				coursesStore.setPage();
			},
			template: `
				<!--<div>this block popular courses...</div>-->
				<PopularCourses/>
			`,
		});

		this.#application.use(pinia);
		this.#application.mount(this.rootNode);
	}
}
